<template>
  <div>
    <vx-card title="Bidding Category" class="mb-base">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow"></div>
        <router-link :to="linkEdit">
          <feather-icon icon="EditIcon" />
        </router-link>
      </div>
      <vs-table
        pagination
        search
        max-items="5"
        :data="data"
        :stripe="true"
        v-if="data != null"
      >
        <template slot="thead">
          <vs-th sort-key="categoryName">Category</vs-th>
          <vs-th sort-key="subCategoryName">Sub Category</vs-th>
          <vs-th sort-key="modifiedDate">Modified Date</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
            <vs-td :data="data[indextr].categoryName">
              {{ data[indextr].categoryName }}
            </vs-td>
            <vs-td :data="data[indextr].subCategoryName">
              {{ data[indextr].subCategoryName }}
            </vs-td>
            <vs-td :data="data[indextr].modifiedDate">
              {{ data[indextr].modifiedDate }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <pre v-if="data == null">No data Available.</pre>
    </vx-card>
  </div>
</template>

<script>
import { _vendorservice } from "../../services/vendorservices";
export default {
  props: {
    propVendorUsername: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      data: [
        { categoryName: "", subCategoryName: "", modifiedDate: new Date() },
      ],
    };
  },
  created() {
    // Delay for Main get Username
    setTimeout(() => {
      this.getCategories();
    }, 2000);
  },
  methods: {
    async getCategories() {
      // console.log(this.propVendorUsername);
      this.data = await _vendorservice.GetVendorCategory(
        this.propVendorUsername,
        0
      );
      // console.log(this.data);
    },
  },
  computed: {
    linkEdit() {
      // /vendor/main/edit/biddingcategory/id/:id/username/:username
      return (
        "/procurement-management/vendor/main/edit/biddingcategory/id/" +
        this.$route.params.id +
        "/username/" +
        this.propVendorUsername
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
